import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';
import { usePaymentState } from 'payment_state/PaymentStateContext';
import IframeBridge from 'IframeBridge';
import { useMutation } from 'react-query';
import { shopifySearch } from 'api/Api';
import { useNavigate } from 'react-router-dom';

const ShopifyConfirmPage = () => {
  const { t } = useTranslation();
  const { shopifyState } = usePaymentState();
  const navigate = useNavigate();

  const transactShopify = useMutation(() => shopifySearch(shopifyState), {
    onSuccess: data => {
      if (data.data.redirectUrl !== null) {
        if (isMobile) {
          window.location.href = data.data.redirectUrl;
        } else {
          IframeBridge.sendShopifyViewOff({
            redirectUrl: data.data.redirectUrl,
          });
        }
      } else {
        navigate('/error');
      }
    },
    onError: error => {
      navigate('/error');
    },
  });

  useEffect(() => {
    if (shopifyState.tid) transactShopify.mutate();
    else navigate('/error');
  }, []);

  return (
    <>
      <div className="completed">
        <div className="middle">
          <div className="title">{t('sending_payment_detail')}</div>
          <div className="text" style={{ whiteSpace: 'pre-line' }}>
            {t('if_u_close_payment_may_not_be_completed')}
          </div>
        </div>
      </div>
    </>
  );
};

export default ShopifyConfirmPage;
